"use client";

import React, { useState } from "react";
import { Button } from "../v3/themed/Button";
import ReimbursementRequestModal from "./ReimbursementRequestModal";
import { EventBySlugOutput } from "~/types/EventTypesInferred";
import { api } from "~/utils/api";
import ReimbursementTermsModal from "./ReimbursementTermsModal";
import { useSession } from "next-auth/react";

type Props = {
    event?: EventBySlugOutput;
    refetch: () => void;
};

const RequestFundingButton = ({ event, refetch }: Props) => {
    const session = useSession();
    const {
        data: mustConfirmReimbursementTermsAndConditions,
        refetch: refetchTermsAndConditionsStatus,
    } = api.reimbursement.mustConfirmReimbursementTermsAndConditions.useQuery(
        {
            communityId: event?.community?.id,
        },
        {
            enabled: !!session?.data?.user,
        },
    );

    const [showReimbursementTermsModal, setShowReimbursementTermsModal] =
        useState(false);
    const [showReimbursementModal, setShowReimbursementModal] = useState(false);

    const handleReimbursementTermsModalClose = async () => {
        await refetchTermsAndConditionsStatus().then((data) => {
            setShowReimbursementTermsModal(false);
        });
    };

    return (
        <>
            <Button
                className="w-full"
                variant="tertiary"
                onClick={() => {
                    if (mustConfirmReimbursementTermsAndConditions) {
                        setShowReimbursementTermsModal(true);
                    } else {
                        setShowReimbursementModal(true);
                    }
                }}
            >
                Request Event Funding
            </Button>

            <ReimbursementTermsModal
                isVisible={showReimbursementTermsModal}
                setIsVisible={() => {
                    setShowReimbursementTermsModal(false);
                }}
                onCompletion={(showReimbursementModal) => {
                    if (showReimbursementModal) {
                        setShowReimbursementModal(true);
                    }
                    setShowReimbursementTermsModal(false);
                }}
                event={event}
            />

            <ReimbursementRequestModal
                isVisible={showReimbursementModal}
                setVisible={setShowReimbursementModal}
                onCompletion={() => {
                    refetch();
                }}
                event={event}
                communityId={event?.community?.id}
                kycLink={event?.community?.reimbursementConfiguration?.kycLink}
            />
        </>
    );
};

export default RequestFundingButton;
